export class Response<T> {
  message: string;
  messageType: MessageType;
  errorCode: ErrorCode;
  data: T;
}

export class PagedTableResponse<T> {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalItems: number;
    hasPrevious: boolean;
    hasNext: boolean;
    items: Array<T>;
}

export enum MessageType {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  IGNORE = 'IGNORE',
}

export enum ErrorCode {
  OK = 'OK',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  DOMAIN_CONFLICT_ALIAS = 'DOMAIN_CONFLICT_ALIAS',
  REQUIRE_PAYMENT = 'REQUIRE_PAYMENT',
  ERR_INACTIVE_MODULE = 'ERR_INACTIVE_MODULE',
  ERR_INVALID_PARAM = 'ERR_INVALID_PARAM',
  INVALID_PARAM = 'INVALID_PARAM',
  ERR_INVALID_UID = 'ERR_INVALID_UID',
  ERR_DUPLICATED_NAME = 'ERR_DUPLICATED_NAME',
  ERR_NOT_FOUND = 'ERR_NOT_FOUND',
  ERR_INVALID_STATE = 'ERR_INVALID_STATE',
  ERR_PROFILE_INVALID_LEVELS = 'ERR_PROFILE_INVALID_LEVELS',
  ERR_PROFILE_INVALID_MODES = 'ERR_PROFILE_INVALID_MODES',
  ERR_PROFILE_LEVEL_REQUIREMENTS = 'ERR_PROFILE_LEVEL_REQUIREMENTS',
  ERR_PROFILE_PRIMARY_NOT_SETTED = 'ERR_PROFILE_PRIMARY_NOT_SETTED',
  ERR_PROFILE_NOT_FOUND_TSA = 'ERR_PROFILE_NOT_FOUND_TSA',
  ERR_PROFILE_NOT_FOUND_CHAIN_CERTIFICATE = 'ERR_PROFILE_NOT_FOUND_CHAIN_CERTIFICATE',
  ERR_PROFILE_INVALID_LEVEL = 'ERR_PROFILE_INVALID_LEVEL',
  ERR_PROFILE_INVALID_CMS_MODE = 'ERR_PROFILE_INVALID_CMS_MODE',
  ERR_PROFILE_INVALID_XMLDSIG_MODE = 'ERR_PROFILE_INVALID_XMLDSIG_MODE',
  ERR_PROFILE_INVALID_CADES_MODE = 'ERR_PROFILE_INVALID_CADES_MODE',
  ERR_PROFILE_INVALID_XADES_MODE = 'ERR_PROFILE_INVALID_XADES_MODE',
  ERR_PROFILE_INVALID_PADES_MODE = 'ERR_PROFILE_INVALID_PADES_MODE',
  ERR_PROFILE_INVALID_SIGNATURE_ALGORITHM = 'ERR_PROFILE_INVALID_SIGNATURE_ALGORITHM',
  ERR_PROFILE_INVALID_DIGEST_ALGORITHM = 'ERR_PROFILE_INVALID_DIGEST_ALGORITHM',
  ERR_PROFILE_INVALID_POLICY = 'ERR_PROFILE_INVALID_POLICY',
  ERR_PROFILE_INVALID_POLICY_HASH_ALGORITHM = 'ERR_PROFILE_INVALID_POLICY_HASH_ALGORITHM',
  ERR_PROFILE_INVALID_POLICY_HASH_VALUE = 'ERR_PROFILE_INVALID_POLICY_HASH_VALUE',
  ERR_PROFILE_INVALID_NAME = 'ERR_PROFILE_INVALID_NAME',
  ERR_NOT_SUPPORTED = 'ERR_NOT_SUPPORTED',
  ERR_CONNECTIVITY = 'ERR_CONNECTIVITY',
  ERR_INVALID_AUTH = 'ERR_INVALID_AUTH',
  ERR_INVALID_CERT = 'ERR_INVALID_CERT',
  SLAVE_SERVER = 'SLAVE_SERVER',
  ERR_ALREADY_EXIST = 'ERR_ALREADY_EXIST',
  ERR_CERTIFICATES_GROUP_MANDATORY = 'ERR_CERTIFICATES_GROUP_MANDATORY',
  ERR_SERVICE_UNAVAILABLE = 'ERR_SERVICE_UNAVAILABLE',
  ERR_OUTDATED = 'ERR_OUTDATED',
  ERR_NOT_ALLOWED_GROUP = 'ERR_NOT_ALLOWED_GROUP',
  ERR_NOT_ALLOWED_CERT = 'ERR_NOT_ALLOWED_CERT',
  ERR_NOT_FOUND_CERT = 'ERR_NOT_FOUND_CERT',
  ERR_NOT_FOUND_GROUP = 'ERR_NOT_FOUND_GROUP',
  ERR_ALERT_CERTIFICATE_USAGE_TYPE_INVALID = 'ERR_ALERT_CERTIFICATE_USAGE_TYPE_INVALID',
  ERR_ALERT_CERTIFICATE_EXPIRATION_INVALID = 'ERR_ALERT_CERTIFICATE_EXPIRATION_INVALID',
  ERROR_CREATING_ALERT = 'ERROR_CREATING_ALERT',
  ERROR_WRONG_EMAIL = 'ERROR_WRONG_EMAIL',
  ALERT_CERTIFICATE_USAGE_TYPE_INVALID = 'ALERT_CERTIFICATE_USAGE_TYPE_INVALID',
  ALERT_CERTIFICATE_EXPIRATION_INVALID = 'ALERT_CERTIFICATE_EXPIRATION_INVALID',
  ERROR_AC_DOMAIN_NOT_FOUND = 'ERROR_AC_DOMAIN_NOT_FOUND',
  ERROR_WRONG_DOMAIN_TYPE = 'ERROR_WRONG_DOMAIN_TYPE',
  ERR_DUPLICATED_GROUP = 'ERR_DUPLICATED_GROUP',
  ERR_GROUP_AND_DOMAIN_NOT_RELATED = 'ERR_GROUP_AND_DOMAIN_NOT_RELATED',
  ERR_PROVISIONED_GROUP = 'ERR_PROVISIONED_GROUP',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  ERR_UPDATE_DATA = 'ERR_UPDATE_DATA',
  MISSING_PARAM = 'MISSING_PARAM',
  ERR_READ_DATA = 'ERR_READ_DATA',
  ERR_GETTING_PERMISSIONS = 'ERR_GETTING_PERMISSIONS',
  ERR_GETTING_ALLOWED_MODULES = 'ERR_GETTING_ALLOWED_MODULES',
  ERR_INVALID_PASSWORD = 'ERR_INVALID_PASSWORD',
  ERR_CLOSING_SESSIONS = 'ERR_CLOSING_SESSIONS',
  ERR_SAME_PASSWORD = 'ERR_SAME_PASSWORD',
  ERR_LICENSE_EXCEEDED = 'ERR_LICENSE_EXCEEDED',
  ERR_NO_FILE = 'ERR_NO_FILE',
  REDIRECT = 'REDIRECT',
  SUPPORTED_NOT_FOUND = 'SUPPORTED_NOT_FOUND',
  WRONG_PIN = 'WRONG_PIN',
}
